import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { SearchIcon } from '@/assets/icons/SearchIcon';

import { SeachWithQueryString } from '../../_types/QuickSearch.types';

import { searchHistoryStyles as sx } from './SearchHistory.styles';

type Props = {
	search: SeachWithQueryString;
};

export const SearchHistory = ({ search: { payload } }: Props) => {
	const { t } = useTranslation();
	const theme = useTheme();

	return (
		<Box sx={sx.root}>
			<Box sx={sx.iconContainer}>
				<SearchIcon sx={sx.icon} fill={theme.palette.primary.main} />
			</Box>

			<Box sx={sx.details}>
				<Typography variant='body2' sx={sx.searchString} noWrap>
					{payload.searchString}
				</Typography>

				<Typography variant='body2' noWrap sx={{ flex: '1 0 auto' }}>
					{t(`in {{entityType}}`, {
						entityType:
							payload.__typename === 'HCPSearchAndFiltersType' ? 'HCP' : 'HCO'
					})}
				</Typography>
			</Box>
		</Box>
	);
};
